module.exports = __webpack_public_path__ + "static/media/wp-logo.bc7784a8.png";